function MarketsIcon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        d="M1 8a7 7 0 0 1 12.584-4.222 2 2 0 0 0-1.604.427 5.5 5.5 0 0 0-1.105-.895 1.85 1.85 0 0 1-1.477.735.353.353 0 0 0-.353.353v.04c0 .587-.272 1.14-.736 1.499l-.462.356a.255.255 0 0 0 .153.457h1.877a3.5 3.5 0 0 0-.592 1.5h-1.285a1.755 1.755 0 0 1-1.07-3.144l.463-.356a.4.4 0 0 0 .152-.312v-.04c0-.885.62-1.624 1.449-1.808a5.5 5.5 0 0 0-5.731 2.613l2 1.999c.472.472.737 1.112.737 1.78v.518a.5.5 0 0 0 .5.5 2 2 0 0 1 2 2v1.478q.385-.036.753-.121c.029.546.277 1.035.658 1.379a7 7 0 0 1-8.911-6.736m1.5 0q.001-.667.152-1.288l1.55 1.55c.19.191.298.45.298.72v.518a2 2 0 0 0 2 2 .5.5 0 0 1 .5.5v1.41a5.5 5.5 0 0 1-4.5-5.41"
      />
      <path d="M13.25 5a.75.75 0 0 1 .75.75v.75h.75a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 0 0 1.5h.5a2.25 2.25 0 0 1 .25 4.486v.264a.75.75 0 0 1-1.5 0v-.25h-.75a.75.75 0 0 1 0-1.5h2a.75.75 0 0 0 0-1.5h-.5a2.25 2.25 0 0 1-.25-4.486v-.764a.75.75 0 0 1 .75-.75" />
    </svg>
  )
}

export default MarketsIcon
